import React from 'react';
import { ICodigoNcm } from '../../../../interfaces/IBaseDeCalculo';
import NCMViewContainer from '../ncmViewContainer/ncmViewContainer';
import styles from './ncmViewContainerList.module.scss';

interface INCMViewContainerListProps {
  codigosNCM: ICodigoNcm[];
}

const NCMViewContainerList: React.FC<INCMViewContainerListProps> = ({ codigosNCM }) => {
  return (
    <div className={styles.container}>
      {codigosNCM.map((codigoNCM) => (
        <NCMViewContainer key={codigoNCM.id} codigoNCM={codigoNCM} />
      ))}
    </div>
  );
};

export default NCMViewContainerList;
